import React, { useState, useEffect } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const testimonials = [
    {
      id: 1,
      name: 'Yamini Khurana',
      role: 'Honeymoon Traveler',
      location: 'Delhi',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
      rating: 5,
      date: 'November 2024',
      tour: 'Shimla Manali Honeymoon Package',
      comment: 'Experience of traveling with Dream to travels has been very satisfactory. We went on a honeymoon trip. All the arrangements were great. The rooms were very spacious and clean. The driver was very professional and helped us throughout. Overall great experience, highly recommended for couples!',
      images: ['🏔️', '💑', '🎂']
    },
    {
      id: 2,
      name: 'Abhishek Malik',
      role: 'Anniversary Celebration',
      location: 'Gurgaon',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
      rating: 5,
      date: 'October 2024',
      tour: 'Mussoorie Romantic Getaway',
      comment: 'Wonderful experience on a great budget. Kudos to Dream to travel. Thank you for the beautiful decoration and Candle Light dinner on our balcony. The cake was also delicious. They made our anniversary so special. The attention to detail was amazing. Recommend to everyone looking for a romantic trip!',
      images: ['🕯️', '🎂', '🌹']
    },
    {
      id: 3,
      name: 'Tamaana Chhabra',
      role: 'Family Vacation',
      location: 'Noida',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
      rating: 5,
      date: 'September 2024',
      tour: 'Rajasthan Family Tour',
      comment: 'We are very pleased to share our travel experience which was organized by Dream to travel. All arrangements were good and accommodations were wonderful. We have been provided with a very good vehicle, caring and knowledgeable driver. We owe a great thanks to the Trip Advisor Mr. Vikas who was in constant touch with us during our trip.',
      images: ['👨‍👩‍👧‍👦', '🏰', '🚐']
    },
    {
      id: 4,
      name: 'Rajesh Sharma',
      role: 'Corporate Group',
      location: 'Mumbai',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
      rating: 5,
      date: 'December 2024',
      tour: 'Leh Ladakh Adventure',
      comment: 'Booked a 20-seater tempo traveller for our company outing to Leh Ladakh. The vehicle was in excellent condition with all amenities. Driver was experienced with mountain driving. Dream to Travels handled all logistics perfectly. Best service for corporate groups!',
      images: ['🏔️', '🚌', '⛺']
    },
    {
      id: 5,
      name: 'Priya Verma',
      role: 'Solo Traveler',
      location: 'Bangalore',
      image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop',
      rating: 5,
      date: 'November 2024',
      tour: 'Jim Corbett Wildlife Safari',
      comment: 'As a solo female traveler, I felt completely safe with Dream to Travels. The driver was respectful and professional. Hotel was secure and comfortable. Saw amazing wildlife at Corbett! Thank you for making my solo trip memorable and worry-free.',
      images: ['🐅', '📸', '🌳']
    },
    {
      id: 6,
      name: 'Amit & Neha Kapoor',
      role: 'Couple Travelers',
      location: 'Chandigarh',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
      rating: 5,
      date: 'October 2024',
      tour: 'Kashmir Paradise Tour',
      comment: 'Kashmir was on our bucket list for years! Dream to Travels made it happen beautifully. The shikara ride, houseboat stay, and Gulmarg visit were perfectly planned. Mr. Vikas coordinated everything seamlessly. Will definitely book again for our next trip!',
      images: ['🚣', '🏔️', '🌺']
    },
    {
      id: 7,
      name: 'Suresh Patel',
      role: 'Pilgrimage Group',
      location: 'Gujarat',
      image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
      rating: 5,
      date: 'September 2024',
      tour: 'Char Dham Yatra',
      comment: 'Organized Char Dham Yatra for 16 people. The tempo traveller was spacious and comfortable for long mountain journeys. Driver knew all the routes well. Accommodations were clean. Everything was arranged as promised. Highly satisfied with the service!',
      images: ['🙏', '⛰️', '🚐']
    },
    {
      id: 8,
      name: 'Kavita Singh',
      role: 'Weekend Traveler',
      location: 'Jaipur',
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop',
      rating: 5,
      date: 'December 2024',
      tour: 'Taj Mahal Day Tour',
      comment: 'Quick same-day tour to Agra was perfectly executed. Picked up on time, comfortable Innova Crysta, knowledgeable driver who doubled as a guide. Saw Taj Mahal, Agra Fort, and had time for shopping. Back home by evening. Excellent service for day trips!',
      images: ['🕌', '📷', '🚗']
    }
  ];

  const stats = [
    { number: '200+', label: 'Happy Customers', icon: '😊' },
    { number: '4.9/5', label: 'Average Rating', icon: '⭐' },
    { number: '10+', label: 'Years Experience', icon: '🏆' },
    { number: '100%', label: 'Satisfaction Rate', icon: '💯' }
  ];

  // Auto-play carousel
  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section
      id="testimonials"
      className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-sky-50 via-blue-50 to-cyan-50 relative overflow-hidden"
    >
      {/* Animated Background */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-sky-300/40 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-300/30 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
      <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-blue-200/25 rounded-full blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-sky-500 via-blue-600 to-cyan-500 drop-shadow-lg mb-4 animate-pulse">
            Our Happy Clients
          </h2>
          <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-600">
            Don't just take our word for it - hear what our customers have to say about their experiences
          </p>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-sky-500 to-cyan-500 mx-auto rounded-full mt-4"></div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12 sm:mb-16">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white/70 backdrop-blur-sm border border-sky-200 rounded-2xl p-6 text-center shadow-lg hover:shadow-xl hover:shadow-sky-300/50 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="text-4xl mb-2">{stat.icon}</div>
              <div className="text-2xl sm:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-sky-500 to-cyan-500 mb-1">
                {stat.number}
              </div>
              <div className="text-sm text-gray-600 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Main Testimonial Carousel */}
        <div className="relative bg-white/70 backdrop-blur-sm border border-sky-200 rounded-3xl shadow-2xl overflow-hidden mb-12">
          <div className="grid lg:grid-cols-2 gap-0">
            {/* Left Side - Image & Info */}
            <div className="bg-gradient-to-br from-sky-400 via-blue-500 to-cyan-500 p-8 sm:p-12 text-white flex flex-col justify-center relative overflow-hidden">
              {/* Decorative Elements */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-32 translate-x-32"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full translate-y-24 -translate-x-24"></div>
              
              <div className="relative z-10">
                {/* Profile Image */}
                <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full border-4 border-white shadow-xl mb-6 overflow-hidden mx-auto lg:mx-0">
                  <img
                    src={currentTestimonial.image}
                    alt={currentTestimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Name & Role */}
                <div className="text-center lg:text-left mb-6">
                  <h3 className="text-2xl sm:text-3xl font-bold mb-2">{currentTestimonial.name}</h3>
                  <p className="text-white/90 font-medium mb-1">{currentTestimonial.role}</p>
                  <p className="text-white/80 text-sm flex items-center justify-center lg:justify-start gap-2">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    {currentTestimonial.location}
                  </p>
                </div>

                {/* Tour Info */}
                <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 mb-6">
                  <p className="text-xs text-white/80 mb-1">Tour Package</p>
                  <p className="font-semibold text-lg">{currentTestimonial.tour}</p>
                  <p className="text-sm text-white/90 mt-2">{currentTestimonial.date}</p>
                </div>

                {/* Rating */}
                <div className="flex items-center justify-center lg:justify-start gap-2 mb-4">
                  {[...Array(currentTestimonial.rating)].map((_, i) => (
                    <svg
                      key={i}
                      className="w-6 h-6 text-yellow-300"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>

                {/* Tour Icons */}
                <div className="flex gap-3 justify-center lg:justify-start">
                  {currentTestimonial.images.map((emoji, i) => (
                    <div
                      key={i}
                      className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-2xl"
                    >
                      {emoji}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Side - Testimonial Content */}
            <div className="p-8 sm:p-12 flex flex-col justify-center bg-white/50">
              {/* Quote Icon */}
              <div className="text-sky-500 mb-6">
                <svg className="w-12 h-12 sm:w-16 sm:h-16 opacity-50" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-8 italic">
                "{currentTestimonial.comment}"
              </p>

              {/* Navigation Arrows */}
              <div className="flex items-center gap-4">
                <button
                  onClick={prevSlide}
                  className="w-12 h-12 rounded-full bg-gradient-to-r from-sky-500 to-blue-600 text-white flex items-center justify-center hover:scale-110 transition-transform shadow-lg"
                  aria-label="Previous testimonial"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>

                <button
                  onClick={nextSlide}
                  className="w-12 h-12 rounded-full bg-gradient-to-r from-cyan-500 to-blue-600 text-white flex items-center justify-center hover:scale-110 transition-transform shadow-lg"
                  aria-label="Next testimonial"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>

                {/* Dots Indicator */}
                <div className="flex gap-2 ml-4">
                  {testimonials.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => goToSlide(index)}
                      className={`transition-all duration-300 rounded-full ${
                        index === currentIndex
                          ? 'w-8 h-3 bg-gradient-to-r from-sky-500 to-cyan-500'
                          : 'w-3 h-3 bg-gray-400 hover:bg-gray-500'
                      }`}
                      aria-label={`Go to testimonial ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* All Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`bg-white/70 backdrop-blur-sm border rounded-2xl shadow-lg p-6 hover:shadow-xl hover:shadow-sky-300/50 hover:-translate-y-2 transition-all duration-300 cursor-pointer ${
                index === currentIndex ? 'ring-2 ring-sky-500 border-sky-400' : 'border-sky-200'
              }`}
              onClick={() => goToSlide(index)}
            >
              {/* Header */}
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-sky-300">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-bold text-gray-900 truncate">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600 truncate">{testimonial.role}</p>
                  <div className="flex gap-1 mt-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <svg key={i} className="w-4 h-4 text-cyan-600" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                </div>
              </div>

              {/* Tour Badge */}
              <div className="bg-sky-100 border border-sky-300 rounded-lg px-3 py-2 mb-3">
                <p className="text-xs text-sky-700 font-semibold truncate">{testimonial.tour}</p>
              </div>

              {/* Comment */}
              <p className="text-sm text-gray-600 leading-relaxed line-clamp-4 mb-4">
                "{testimonial.comment}"
              </p>

              {/* Footer */}
              <div className="flex items-center justify-between text-xs text-gray-500">
                <span className="flex items-center gap-1">
                  <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  {testimonial.date}
                </span>
                <span className="flex items-center gap-1">
                  <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                  {testimonial.location}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-sky-400 via-blue-500 to-cyan-400 p-1 rounded-2xl shadow-2xl shadow-sky-400/30">
            <div className="bg-white rounded-2xl p-8 sm:p-10">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
                Ready to Create Your Own Story?
              </h3>
              <p className="text-gray-600 mb-6 max-w-xl mx-auto">
                Join thousands of satisfied travelers and let us plan your perfect journey
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="https://wa.me/918929550611?text=Hi! I want to plan a trip with Dream To Travels"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-bold rounded-full shadow-lg hover:shadow-cyan-400/50 hover:scale-105 transition-transform duration-200 flex items-center justify-center gap-2"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  Start Planning Your Trip
                </a>
                <a
                  href="tel:+918929550611"
                  className="px-8 py-4 bg-gradient-to-r from-sky-500 to-blue-600 text-white font-bold rounded-full shadow-lg hover:shadow-sky-400/50 hover:scale-105 transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  Call: +91-8929550611
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}


// import React, { useState, useEffect } from 'react';

// export default function Testimonials() {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isAutoPlaying, setIsAutoPlaying] = useState(true);

//   const testimonials = [
//     {
//       id: 1,
//       name: 'Yamini Khurana',
//       role: 'Honeymoon Traveler',
//       location: 'Delhi',
//       image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'November 2024',
//       tour: 'Shimla Manali Honeymoon Package',
//       comment: 'Experience of traveling with Dream to travels has been very satisfactory. We went on a honeymoon trip. All the arrangements were great. The rooms were very spacious and clean. The driver was very professional and helped us throughout. Overall great experience, highly recommended for couples!',
//       images: ['🏔️', '💑', '🎂']
//     },
//     {
//       id: 2,
//       name: 'Abhishek Malik',
//       role: 'Anniversary Celebration',
//       location: 'Gurgaon',
//       image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'October 2024',
//       tour: 'Mussoorie Romantic Getaway',
//       comment: 'Wonderful experience on a great budget. Kudos to Dream to travel. Thank you for the beautiful decoration and Candle Light dinner on our balcony. The cake was also delicious. They made our anniversary so special. The attention to detail was amazing. Recommend to everyone looking for a romantic trip!',
//       images: ['🕯️', '🎂', '🌹']
//     },
//     {
//       id: 3,
//       name: 'Tamaana Chhabra',
//       role: 'Family Vacation',
//       location: 'Noida',
//       image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'September 2024',
//       tour: 'Rajasthan Family Tour',
//       comment: 'We are very pleased to share our travel experience which was organized by Dream to travel. All arrangements were good and accommodations were wonderful. We have been provided with a very good vehicle, caring and knowledgeable driver. We owe a great thanks to the Trip Advisor Mr. Vikas who was in constant touch with us during our trip.',
//       images: ['👨‍👩‍👧‍👦', '🏰', '🚐']
//     },
//     {
//       id: 4,
//       name: 'Rajesh Sharma',
//       role: 'Corporate Group',
//       location: 'Mumbai',
//       image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'December 2024',
//       tour: 'Leh Ladakh Adventure',
//       comment: 'Booked a 20-seater tempo traveller for our company outing to Leh Ladakh. The vehicle was in excellent condition with all amenities. Driver was experienced with mountain driving. Dream to Travels handled all logistics perfectly. Best service for corporate groups!',
//       images: ['🏔️', '🚌', '⛺']
//     },
//     {
//       id: 5,
//       name: 'Priya Verma',
//       role: 'Solo Traveler',
//       location: 'Bangalore',
//       image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'November 2024',
//       tour: 'Jim Corbett Wildlife Safari',
//       comment: 'As a solo female traveler, I felt completely safe with Dream to Travels. The driver was respectful and professional. Hotel was secure and comfortable. Saw amazing wildlife at Corbett! Thank you for making my solo trip memorable and worry-free.',
//       images: ['🐅', '📸', '🌳']
//     },
//     {
//       id: 6,
//       name: 'Amit & Neha Kapoor',
//       role: 'Couple Travelers',
//       location: 'Chandigarh',
//       image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'October 2024',
//       tour: 'Kashmir Paradise Tour',
//       comment: 'Kashmir was on our bucket list for years! Dream to Travels made it happen beautifully. The shikara ride, houseboat stay, and Gulmarg visit were perfectly planned. Mr. Vikas coordinated everything seamlessly. Will definitely book again for our next trip!',
//       images: ['🚣', '🏔️', '🌺']
//     },
//     {
//       id: 7,
//       name: 'Suresh Patel',
//       role: 'Pilgrimage Group',
//       location: 'Gujarat',
//       image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'September 2024',
//       tour: 'Char Dham Yatra',
//       comment: 'Organized Char Dham Yatra for 16 people. The tempo traveller was spacious and comfortable for long mountain journeys. Driver knew all the routes well. Accommodations were clean. Everything was arranged as promised. Highly satisfied with the service!',
//       images: ['🙏', '⛰️', '🚐']
//     },
//     {
//       id: 8,
//       name: 'Kavita Singh',
//       role: 'Weekend Traveler',
//       location: 'Jaipur',
//       image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'December 2024',
//       tour: 'Taj Mahal Day Tour',
//       comment: 'Quick same-day tour to Agra was perfectly executed. Picked up on time, comfortable Innova Crysta, knowledgeable driver who doubled as a guide. Saw Taj Mahal, Agra Fort, and had time for shopping. Back home by evening. Excellent service for day trips!',
//       images: ['🕌', '📷', '🚗']
//     }
//   ];

//   const stats = [
//     { number: '5000+', label: 'Happy Customers', icon: '😊' },
//     { number: '4.9/5', label: 'Average Rating', icon: '⭐' },
//     { number: '10+', label: 'Years Experience', icon: '🏆' },
//     { number: '100%', label: 'Satisfaction Rate', icon: '💯' }
//   ];

//   // Auto-play carousel
//   useEffect(() => {
//     if (!isAutoPlaying) return;
    
//     const interval = setInterval(() => {
//       setCurrentIndex((prev) => (prev + 1) % testimonials.length);
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [isAutoPlaying, testimonials.length]);

//   const goToSlide = (index) => {
//     setCurrentIndex(index);
//     setIsAutoPlaying(false);
//   };

//   const nextSlide = () => {
//     setCurrentIndex((prev) => (prev + 1) % testimonials.length);
//     setIsAutoPlaying(false);
//   };

//   const prevSlide = () => {
//     setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//     setIsAutoPlaying(false);
//   };

//   const currentTestimonial = testimonials[currentIndex];

//   return (
//     <section
//       id="testimonials"
//       className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-gray-900 via-blue-950 to-gray-900 relative overflow-hidden"
//     >
//       {/* Animated Background */}
//       <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
//       <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>

//       <div className="max-w-7xl mx-auto relative z-10">
//         {/* Section Header */}
//         <div className="text-center mb-12 sm:mb-16">
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-blue-300 to-orange-400 drop-shadow mb-4">
//             Our Happy Clients
//           </h2>
//           <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-300">
//             Don't just take our word for it - hear what our customers have to say about their experiences
//           </p>
//           <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-blue-500 to-orange-500 mx-auto rounded-full mt-4"></div>
//         </div>

//         {/* Stats Section */}
//         <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12 sm:mb-16">
//           {stats.map((stat, index) => (
//             <div
//               key={index}
//               className="bg-gray-800/50 backdrop-blur-sm border border-blue-500/20 rounded-2xl p-6 text-center shadow-lg hover:shadow-xl hover:shadow-blue-500/20 hover:-translate-y-1 transition-all duration-300"
//             >
//               <div className="text-4xl mb-2">{stat.icon}</div>
//               <div className="text-2xl sm:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-orange-400 mb-1">
//                 {stat.number}
//               </div>
//               <div className="text-sm text-gray-300 font-medium">{stat.label}</div>
//             </div>
//           ))}
//         </div>

//         {/* Main Testimonial Carousel */}
//         <div className="relative bg-gray-800/50 backdrop-blur-sm border border-blue-500/20 rounded-3xl shadow-2xl overflow-hidden mb-12">
//           <div className="grid lg:grid-cols-2 gap-0">
//             {/* Left Side - Image & Info */}
//             <div className="bg-gradient-to-br from-blue-600 via-blue-500 to-orange-500 p-8 sm:p-12 text-white flex flex-col justify-center relative overflow-hidden">
//               {/* Decorative Elements */}
//               <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-32 translate-x-32"></div>
//               <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full translate-y-24 -translate-x-24"></div>
              
//               <div className="relative z-10">
//                 {/* Profile Image */}
//                 <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full border-4 border-white shadow-xl mb-6 overflow-hidden mx-auto lg:mx-0">
//                   <img
//                     src={currentTestimonial.image}
//                     alt={currentTestimonial.name}
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 {/* Name & Role */}
//                 <div className="text-center lg:text-left mb-6">
//                   <h3 className="text-2xl sm:text-3xl font-bold mb-2">{currentTestimonial.name}</h3>
//                   <p className="text-white/90 font-medium mb-1">{currentTestimonial.role}</p>
//                   <p className="text-white/80 text-sm flex items-center justify-center lg:justify-start gap-2">
//                     <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//                       <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
//                     </svg>
//                     {currentTestimonial.location}
//                   </p>
//                 </div>

//                 {/* Tour Info */}
//                 <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 mb-6">
//                   <p className="text-xs text-white/80 mb-1">Tour Package</p>
//                   <p className="font-semibold text-lg">{currentTestimonial.tour}</p>
//                   <p className="text-sm text-white/90 mt-2">{currentTestimonial.date}</p>
//                 </div>

//                 {/* Rating */}
//                 <div className="flex items-center justify-center lg:justify-start gap-2 mb-4">
//                   {[...Array(currentTestimonial.rating)].map((_, i) => (
//                     <svg
//                       key={i}
//                       className="w-6 h-6 text-orange-300"
//                       fill="currentColor"
//                       viewBox="0 0 20 20"
//                     >
//                       <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                     </svg>
//                   ))}
//                 </div>

//                 {/* Tour Icons */}
//                 <div className="flex gap-3 justify-center lg:justify-start">
//                   {currentTestimonial.images.map((emoji, i) => (
//                     <div
//                       key={i}
//                       className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-2xl"
//                     >
//                       {emoji}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* Right Side - Testimonial Content */}
//             <div className="p-8 sm:p-12 flex flex-col justify-center bg-gray-800/30">
//               {/* Quote Icon */}
//               <div className="text-blue-400 mb-6">
//                 <svg className="w-12 h-12 sm:w-16 sm:h-16 opacity-50" fill="currentColor" viewBox="0 0 24 24">
//                   <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
//                 </svg>
//               </div>

//               {/* Testimonial Text */}
//               <p className="text-gray-300 text-base sm:text-lg leading-relaxed mb-8 italic">
//                 "{currentTestimonial.comment}"
//               </p>

//               {/* Navigation Arrows */}
//               <div className="flex items-center gap-4">
//                 <button
//                   onClick={prevSlide}
//                   className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 text-white flex items-center justify-center hover:scale-110 transition-transform shadow-lg"
//                   aria-label="Previous testimonial"
//                 >
//                   <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                   </svg>
//                 </button>

//                 <button
//                   onClick={nextSlide}
//                   className="w-12 h-12 rounded-full bg-gradient-to-r from-orange-500 to-orange-600 text-white flex items-center justify-center hover:scale-110 transition-transform shadow-lg"
//                   aria-label="Next testimonial"
//                 >
//                   <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                   </svg>
//                 </button>

//                 {/* Dots Indicator */}
//                 <div className="flex gap-2 ml-4">
//                   {testimonials.map((_, index) => (
//                     <button
//                       key={index}
//                       onClick={() => goToSlide(index)}
//                       className={`transition-all duration-300 rounded-full ${
//                         index === currentIndex
//                           ? 'w-8 h-3 bg-gradient-to-r from-blue-500 to-orange-500'
//                           : 'w-3 h-3 bg-gray-600 hover:bg-gray-500'
//                       }`}
//                       aria-label={`Go to testimonial ${index + 1}`}
//                     />
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* All Testimonials Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {testimonials.map((testimonial, index) => (
//             <div
//               key={testimonial.id}
//               className={`bg-gray-800/50 backdrop-blur-sm border rounded-2xl shadow-lg p-6 hover:shadow-xl hover:shadow-blue-500/20 hover:-translate-y-2 transition-all duration-300 cursor-pointer ${
//                 index === currentIndex ? 'ring-2 ring-blue-500 border-blue-500/40' : 'border-blue-500/20'
//               }`}
//               onClick={() => goToSlide(index)}
//             >
//               {/* Header */}
//               <div className="flex items-center gap-4 mb-4">
//                 <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-blue-500/30">
//                   <img
//                     src={testimonial.image}
//                     alt={testimonial.name}
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//                 <div className="flex-1 min-w-0">
//                   <h4 className="font-bold text-white truncate">{testimonial.name}</h4>
//                   <p className="text-sm text-gray-400 truncate">{testimonial.role}</p>
//                   <div className="flex gap-1 mt-1">
//                     {[...Array(testimonial.rating)].map((_, i) => (
//                       <svg key={i} className="w-4 h-4 text-orange-400" fill="currentColor" viewBox="0 0 20 20">
//                         <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                       </svg>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* Tour Badge */}
//               <div className="bg-blue-500/20 border border-blue-400/30 rounded-lg px-3 py-2 mb-3">
//                 <p className="text-xs text-blue-300 font-semibold truncate">{testimonial.tour}</p>
//               </div>

//               {/* Comment */}
//               <p className="text-sm text-gray-300 leading-relaxed line-clamp-4 mb-4">
//                 "{testimonial.comment}"
//               </p>

//               {/* Footer */}
//               <div className="flex items-center justify-between text-xs text-gray-400">
//                 <span className="flex items-center gap-1">
//                   <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
//                   </svg>
//                   {testimonial.date}
//                 </span>
//                 <span className="flex items-center gap-1">
//                   <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
//                   </svg>
//                   {testimonial.location}
//                 </span>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Call to Action */}
//         <div className="mt-16 text-center">
//           <div className="inline-block bg-gradient-to-r from-blue-500 via-blue-400 to-orange-500 p-1 rounded-2xl shadow-2xl shadow-blue-500/30">
//             <div className="bg-gray-900 rounded-2xl p-8 sm:p-10">
//               <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3">
//                 Ready to Create Your Own Story?
//               </h3>
//               <p className="text-gray-300 mb-6 max-w-xl mx-auto">
//                 Join thousands of satisfied travelers and let us plan your perfect journey
//               </p>
//               <div className="flex flex-col sm:flex-row gap-4 justify-center">
//                 <a
//                   href="https://wa.me/918929550611?text=Hi! I want to plan a trip with Dream To Travels"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold rounded-full shadow-lg hover:shadow-orange-500/50 hover:scale-105 transition-transform duration-200 flex items-center justify-center gap-2"
//                 >
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//                   </svg>
//                   Start Planning Your Trip
//                 </a>
//                 <a
//                   href="tel:+918929550611"
//                   className="px-8 py-4 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold rounded-full shadow-lg hover:shadow-blue-500/50 hover:scale-105 transition-all duration-200 flex items-center justify-center gap-2"
//                 >
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
//                   </svg>
//                   Call: +91-8929550611
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// import React, { useState, useEffect } from 'react';

// export default function Testimonials() {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isAutoPlaying, setIsAutoPlaying] = useState(true);

//   const testimonials = [
//     {
//       id: 1,
//       name: 'Yamini Khurana',
//       role: 'Honeymoon Traveler',
//       location: 'Delhi',
//       image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'November 2024',
//       tour: 'Shimla Manali Honeymoon Package',
//       comment: 'Experience of traveling with Dream to travels has been very satisfactory. We went on a honeymoon trip. All the arrangements were great. The rooms were very spacious and clean. The driver was very professional and helped us throughout. Overall great experience, highly recommended for couples!',
//       images: ['🏔️', '💑', '🎂']
//     },
//     {
//       id: 2,
//       name: 'Abhishek Malik',
//       role: 'Anniversary Celebration',
//       location: 'Gurgaon',
//       image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'October 2024',
//       tour: 'Mussoorie Romantic Getaway',
//       comment: 'Wonderful experience on a great budget. Kudos to Dream to travel. Thank you for the beautiful decoration and Candle Light dinner on our balcony. The cake was also delicious. They made our anniversary so special. The attention to detail was amazing. Recommend to everyone looking for a romantic trip!',
//       images: ['🕯️', '🎂', '🌹']
//     },
//     {
//       id: 3,
//       name: 'Tamaana Chhabra',
//       role: 'Family Vacation',
//       location: 'Noida',
//       image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'September 2024',
//       tour: 'Rajasthan Family Tour',
//       comment: 'We are very pleased to share our travel experience which was organized by Dream to travel. All arrangements were good and accommodations were wonderful. We have been provided with a very good vehicle, caring and knowledgeable driver. We owe a great thanks to the Trip Advisor Mr. Vikas who was in constant touch with us during our trip.',
//       images: ['👨‍👩‍👧‍👦', '🏰', '🚐']
//     },
//     {
//       id: 4,
//       name: 'Rajesh Sharma',
//       role: 'Corporate Group',
//       location: 'Mumbai',
//       image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'December 2024',
//       tour: 'Leh Ladakh Adventure',
//       comment: 'Booked a 20-seater tempo traveller for our company outing to Leh Ladakh. The vehicle was in excellent condition with all amenities. Driver was experienced with mountain driving. Dream to Travels handled all logistics perfectly. Best service for corporate groups!',
//       images: ['🏔️', '🚌', '⛺']
//     },
//     {
//       id: 5,
//       name: 'Priya Verma',
//       role: 'Solo Traveler',
//       location: 'Bangalore',
//       image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'November 2024',
//       tour: 'Jim Corbett Wildlife Safari',
//       comment: 'As a solo female traveler, I felt completely safe with Dream to Travels. The driver was respectful and professional. Hotel was secure and comfortable. Saw amazing wildlife at Corbett! Thank you for making my solo trip memorable and worry-free.',
//       images: ['🐅', '📸', '🌳']
//     },
//     {
//       id: 6,
//       name: 'Amit & Neha Kapoor',
//       role: 'Couple Travelers',
//       location: 'Chandigarh',
//       image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'October 2024',
//       tour: 'Kashmir Paradise Tour',
//       comment: 'Kashmir was on our bucket list for years! Dream to Travels made it happen beautifully. The shikara ride, houseboat stay, and Gulmarg visit were perfectly planned. Mr. Vikas coordinated everything seamlessly. Will definitely book again for our next trip!',
//       images: ['🚣', '🏔️', '🌺']
//     },
//     {
//       id: 7,
//       name: 'Suresh Patel',
//       role: 'Pilgrimage Group',
//       location: 'Gujarat',
//       image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'September 2024',
//       tour: 'Char Dham Yatra',
//       comment: 'Organized Char Dham Yatra for 16 people. The tempo traveller was spacious and comfortable for long mountain journeys. Driver knew all the routes well. Accommodations were clean. Everything was arranged as promised. Highly satisfied with the service!',
//       images: ['🙏', '⛰️', '🚐']
//     },
//     {
//       id: 8,
//       name: 'Kavita Singh',
//       role: 'Weekend Traveler',
//       location: 'Jaipur',
//       image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop',
//       rating: 5,
//       date: 'December 2024',
//       tour: 'Taj Mahal Day Tour',
//       comment: 'Quick same-day tour to Agra was perfectly executed. Picked up on time, comfortable Innova Crysta, knowledgeable driver who doubled as a guide. Saw Taj Mahal, Agra Fort, and had time for shopping. Back home by evening. Excellent service for day trips!',
//       images: ['🕌', '📷', '🚗']
//     }
//   ];

//   const stats = [
//     { number: '5000+', label: 'Happy Customers', icon: '😊' },
//     { number: '4.9/5', label: 'Average Rating', icon: '⭐' },
//     { number: '10+', label: 'Years Experience', icon: '🏆' },
//     { number: '100%', label: 'Satisfaction Rate', icon: '💯' }
//   ];

//   // Auto-play carousel
//   useEffect(() => {
//     if (!isAutoPlaying) return;
    
//     const interval = setInterval(() => {
//       setCurrentIndex((prev) => (prev + 1) % testimonials.length);
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [isAutoPlaying, testimonials.length]);

//   const goToSlide = (index) => {
//     setCurrentIndex(index);
//     setIsAutoPlaying(false);
//   };

//   const nextSlide = () => {
//     setCurrentIndex((prev) => (prev + 1) % testimonials.length);
//     setIsAutoPlaying(false);
//   };

//   const prevSlide = () => {
//     setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//     setIsAutoPlaying(false);
//   };

//   const currentTestimonial = testimonials[currentIndex];

//   return (
//     <section
//       id="testimonials"
//       className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-pink-50 via-white to-blue-50"
//     >
//       <div className="max-w-7xl mx-auto">
//         {/* Section Header */}
//         <div className="text-center mb-12 sm:mb-16">
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-600 to-blue-500 drop-shadow mb-4">
//             Our Happy Clients
//           </h2>
//           <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-700">
//             Don't just take our word for it - hear what our customers have to say about their experiences
//           </p>
//           <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-pink-500 to-blue-500 mx-auto rounded-full mt-4"></div>
//         </div>

//         {/* Stats Section */}
//         <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12 sm:mb-16">
//           {stats.map((stat, index) => (
//             <div
//               key={index}
//               className="bg-white rounded-2xl p-6 text-center shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
//             >
//               <div className="text-4xl mb-2">{stat.icon}</div>
//               <div className="text-2xl sm:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600 mb-1">
//                 {stat.number}
//               </div>
//               <div className="text-sm text-gray-600 font-medium">{stat.label}</div>
//             </div>
//           ))}
//         </div>

//         {/* Main Testimonial Carousel */}
//         <div className="relative bg-white rounded-3xl shadow-2xl overflow-hidden mb-12">
//           <div className="grid lg:grid-cols-2 gap-0">
//             {/* Left Side - Image & Info */}
//             <div className="bg-gradient-to-br from-purple-500 via-pink-500 to-blue-500 p-8 sm:p-12 text-white flex flex-col justify-center relative overflow-hidden">
//               {/* Decorative Elements */}
//               <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-32 translate-x-32"></div>
//               <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full translate-y-24 -translate-x-24"></div>
              
//               <div className="relative z-10">
//                 {/* Profile Image */}
//                 <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full border-4 border-white shadow-xl mb-6 overflow-hidden mx-auto lg:mx-0">
//                   <img
//                     src={currentTestimonial.image}
//                     alt={currentTestimonial.name}
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 {/* Name & Role */}
//                 <div className="text-center lg:text-left mb-6">
//                   <h3 className="text-2xl sm:text-3xl font-bold mb-2">{currentTestimonial.name}</h3>
//                   <p className="text-white/90 font-medium mb-1">{currentTestimonial.role}</p>
//                   <p className="text-white/80 text-sm flex items-center justify-center lg:justify-start gap-2">
//                     <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//                       <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
//                     </svg>
//                     {currentTestimonial.location}
//                   </p>
//                 </div>

//                 {/* Tour Info */}
//                 <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 mb-6">
//                   <p className="text-xs text-white/80 mb-1">Tour Package</p>
//                   <p className="font-semibold text-lg">{currentTestimonial.tour}</p>
//                   <p className="text-sm text-white/90 mt-2">{currentTestimonial.date}</p>
//                 </div>

//                 {/* Rating */}
//                 <div className="flex items-center justify-center lg:justify-start gap-2 mb-4">
//                   {[...Array(currentTestimonial.rating)].map((_, i) => (
//                     <svg
//                       key={i}
//                       className="w-6 h-6 text-yellow-300"
//                       fill="currentColor"
//                       viewBox="0 0 20 20"
//                     >
//                       <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                     </svg>
//                   ))}
//                 </div>

//                 {/* Tour Icons */}
//                 <div className="flex gap-3 justify-center lg:justify-start">
//                   {currentTestimonial.images.map((emoji, i) => (
//                     <div
//                       key={i}
//                       className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-2xl"
//                     >
//                       {emoji}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* Right Side - Testimonial Content */}
//             <div className="p-8 sm:p-12 flex flex-col justify-center">
//               {/* Quote Icon */}
//               <div className="text-purple-500 mb-6">
//                 <svg className="w-12 h-12 sm:w-16 sm:h-16 opacity-50" fill="currentColor" viewBox="0 0 24 24">
//                   <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
//                 </svg>
//               </div>

//               {/* Testimonial Text */}
//               <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-8 italic">
//                 "{currentTestimonial.comment}"
//               </p>

//               {/* Navigation Arrows */}
//               <div className="flex items-center gap-4">
//                 <button
//                   onClick={prevSlide}
//                   className="w-12 h-12 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 text-white flex items-center justify-center hover:scale-110 transition-transform shadow-lg"
//                   aria-label="Previous testimonial"
//                 >
//                   <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                   </svg>
//                 </button>

//                 <button
//                   onClick={nextSlide}
//                   className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 text-white flex items-center justify-center hover:scale-110 transition-transform shadow-lg"
//                   aria-label="Next testimonial"
//                 >
//                   <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                   </svg>
//                 </button>

//                 {/* Dots Indicator */}
//                 <div className="flex gap-2 ml-4">
//                   {testimonials.map((_, index) => (
//                     <button
//                       key={index}
//                       onClick={() => goToSlide(index)}
//                       className={`transition-all duration-300 rounded-full ${
//                         index === currentIndex
//                           ? 'w-8 h-3 bg-gradient-to-r from-purple-500 to-blue-500'
//                           : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'
//                       }`}
//                       aria-label={`Go to testimonial ${index + 1}`}
//                     />
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* All Testimonials Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {testimonials.map((testimonial, index) => (
//             <div
//               key={testimonial.id}
//               className={`bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer ${
//                 index === currentIndex ? 'ring-2 ring-purple-500' : ''
//               }`}
//               onClick={() => goToSlide(index)}
//             >
//               {/* Header */}
//               <div className="flex items-center gap-4 mb-4">
//                 <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0">
//                   <img
//                     src={testimonial.image}
//                     alt={testimonial.name}
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//                 <div className="flex-1 min-w-0">
//                   <h4 className="font-bold text-gray-800 truncate">{testimonial.name}</h4>
//                   <p className="text-sm text-gray-600 truncate">{testimonial.role}</p>
//                   <div className="flex gap-1 mt-1">
//                     {[...Array(testimonial.rating)].map((_, i) => (
//                       <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
//                         <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                       </svg>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* Tour Badge */}
//               <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg px-3 py-2 mb-3">
//                 <p className="text-xs text-purple-700 font-semibold truncate">{testimonial.tour}</p>
//               </div>

//               {/* Comment */}
//               <p className="text-sm text-gray-600 leading-relaxed line-clamp-4 mb-4">
//                 "{testimonial.comment}"
//               </p>

//               {/* Footer */}
//               <div className="flex items-center justify-between text-xs text-gray-500">
//                 <span className="flex items-center gap-1">
//                   <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
//                   </svg>
//                   {testimonial.date}
//                 </span>
//                 <span className="flex items-center gap-1">
//                   <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
//                   </svg>
//                   {testimonial.location}
//                 </span>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Call to Action */}
//         <div className="mt-16 text-center">
//           <div className="inline-block bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 p-1 rounded-2xl shadow-xl">
//             <div className="bg-white rounded-2xl p-8 sm:p-10">
//               <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-3">
//                 Ready to Create Your Own Story?
//               </h3>
//               <p className="text-gray-600 mb-6 max-w-xl mx-auto">
//                 Join thousands of satisfied travelers and let us plan your perfect journey
//               </p>
//               <div className="flex flex-col sm:flex-row gap-4 justify-center">
//                 <a
//                   href="https://wa.me/917027005176?text=Hi! I want to plan a trip with Dream To Travels"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white font-bold rounded-full shadow-lg hover:scale-105 transition-transform duration-200 flex items-center justify-center gap-2"
//                 >
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//                   </svg>
//                   Start Planning Your Trip
//                 </a>
//                 <a
//                   href="tel:+917027005176"
//                   className="px-8 py-4 bg-white border-2 border-purple-500 text-purple-600 font-bold rounded-full hover:bg-purple-50 transition-all duration-200 flex items-center justify-center gap-2"
//                 >
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
//                   </svg>
//                   Call: +91-7027005176
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }